import { Localized } from "@fluent/react";
import { Alert, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useCallback, useState } from "react";
import { AppTextFieldHandler } from "../../../app/appTypes";
import { useAppDispatch } from "../../../app/hooks";
import { showError, showSuccess } from "../../notifications/notificationsSlice";
import { CancelButton } from "../../../app/components/CancelButton";
import { DeleteButton } from "../../../app/components/DeleteButton";
import { deleteMailingGroup } from "./mailingGroupApi";

export interface DeleteMailingGroupDialogProps {
    mailingGroupId: string;
    onSuccess: (deletedMailingGroupId: string) => void;
    onCancel: () => void;
}

export const DeleteMailingGroupDialog: React.FC<DeleteMailingGroupDialogProps> = ({
    mailingGroupId,
    onSuccess,
    onCancel }) => {
    const dispatch = useAppDispatch()

    const [saving, setSaving] = useState(false);
    const [password, setPassword] = useState("")
    const [serverError, setServerError] = useState("")

    const handlePasswordFieldChange: AppTextFieldHandler = useCallback(e => {
        setPassword(e.target.value)
    }, [])


    const handleConfirmClick = async () => {
        if (password && mailingGroupId) {
            setSaving(true)
            try {
                const result = await dispatch(deleteMailingGroup({
                    mailingGroupId: mailingGroupId,
                    password: password
                }));
                if (deleteMailingGroup.fulfilled.match(result)) {
                    dispatch(showSuccess("deleted"))
                    onSuccess(result.payload);
                }
                else {
                    let errorMsg = "error"
                    if (result.payload) {
                        if (result.payload.kind === 'http') {
                            const problem = result.payload.problem
                            if (problem) {
                                errorMsg = problem.title
                            }
                            setServerError(errorMsg)
                        }
                    }
                }
            }
            catch (error) {

                dispatch(showError("error"))
            }
            setSaving(false)
        }
    }

    return (
        <Dialog maxWidth="sm" open={true} onClose={onCancel} fullWidth >
            <DialogTitle>
                <Localized id="company-settings-delete-mailing-group-confirmation">
                    <span>_Czy na pewno chcesz usunąć grupę mailingową?</span>
                </Localized>
            </DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    fullWidth
                    sx={{ marginTop: 2 }}
                    InputLabelProps={{ shrink: true }}
                    type="password"
                    value={password}
                    onChange={handlePasswordFieldChange}
                    label={<Localized id="password"><span>Hasło</span></Localized>}
                    helperText={<Localized id="autorization-password-required"><span>Wymagana autoryzacja hasłem</span></Localized>}
                    autoComplete="off"
                    aria-required="true"
                />
                {
                    serverError && <Alert sx={{ marginTop: 1, }} onClose={() => { setServerError("") }} severity="error">
                        <Localized id={serverError}>
                            <span>Server error</span>
                        </Localized>
                    </Alert>
                }
            </DialogContent>
            <DialogActions>
                <DeleteButton loading={saving} onClick={handleConfirmClick}></DeleteButton>
                <CancelButton loading={saving} onClick={onCancel}></CancelButton>
            </DialogActions>
        </Dialog>
    )
}
